<template>
  <div class="dou-yin-account-list">
    <sp-tabs v-model="active_index" :tabs="tabs">
      <template #default="{ tabs }">
        <dou-yin-account-list :key="active_index" v-bind="tabs[active_index].componentProps" />
      </template>
    </sp-tabs>
  </div>
</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';

export default {
  components: {
    'sp-tabs': () => import('@/components/sp-tabs'),
    'dou-yin-account-list': () => import('./components/dou-yin-account-list/index.vue'),
  },
  mixins: [data_sharing_mixin],
  props: {
    formItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      active_index: 0,
    };
  },
  computed: {
    tabs() {
      const { campaign_config } = this.local_sharing_data.getFormFields();
      const { delivery_form } = campaign_config.config;
      const { fusion__channel_code, star_task_switch, star_tasks } = delivery_form.config;
      const { fusion__channel_codes } = fusion__channel_code.children;
      return fusion__channel_codes.value.map(advertiser => {
        return {
          label: advertiser.label,
          componentProps: {
            formItem: this.formItem,
            advertiserId: advertiser.advertiser_id,
            starTaskSwitch: star_task_switch.value,
            starTasks: star_tasks.value,
          },
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dou-yin-account-list {
  height: 500px;
}
</style>
